<template>
    <section class="stf-sheet">
        <slot></slot>
    </section>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
@use "bulma/sass/utilities/mixins";
@use '@/assets/sass/_variables' as vars;

.stf-sheet {
  border-radius: 10px;
  background-color: vars.$color-gray-50;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;

  @include mixins.mobile {
    border-radius: 9px;
    padding: 15px;
  }
}
</style>
